import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'

import { Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'description'>

export const Introduction = ({ description }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-3">
      <Heading>{t('unit_detail.title')}</Heading>
      <p className="typo-body2-reading font-normal whitespace-break-spaces text-gray-900">
        {description}
      </p>
    </section>
  )
}
